import { render, staticRenderFns } from "./ApproveChangesDialog.vue?vue&type=template&id=7442758c&"
import script from "./ApproveChangesDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveChangesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports